module.exports = __webpack_public_path__ + "img/wt4.6c7a098a.png";